import { render } from "./MdList.vue?vue&type=template&id=039748e2"
import script from "./MdList.vue?vue&type=script&lang=js"
export * from "./MdList.vue?vue&type=script&lang=js"

import "./MdList.vue?vue&type=style&index=0&id=039748e2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__